const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || "";
const GA_ALLOWED_HOSTS = process.env.REACT_APP_GA_ALLOWED_HOSTS || "electionmap.cz";
const CLARITY_PROJECT_ID = process.env.REACT_APP_CLARITY_PROJECT_ID || "";
const CLARITY_ALLOWED_HOSTS = process.env.REACT_APP_CLARITY_ALLOWED_HOSTS || "electionmap.cz";
export const ANALYTICS_CONSENT_KEY = "electionmap.analyticsConsent";
export const ANALYTICS_CONSENT_ACCEPTED = "accepted";
export const ANALYTICS_CONSENT_REJECTED = "rejected";

function getCurrentHostname() {
  if (typeof window === "undefined" || !window.location) return "";
  return window.location.hostname;
}

function isValidMeasurementId(measurementId) {
  return /^G-[A-Z0-9]+$/i.test(measurementId);
}

function isValidClarityProjectId(projectId) {
  return /^[a-z0-9]+$/i.test(projectId);
}

function getAllowedHosts(rawHosts) {
  return rawHosts.split(",")
    .map((host) => host.trim().toLowerCase())
    .filter(Boolean);
}

export function getAnalyticsConsent() {
  if (typeof window === "undefined" || !window.localStorage) return null;
  try {
    const value = window.localStorage.getItem(ANALYTICS_CONSENT_KEY);
    if (value === ANALYTICS_CONSENT_ACCEPTED || value === ANALYTICS_CONSENT_REJECTED) {
      return value;
    }
  } catch (_) {
    return null;
  }
  return null;
}

export function setAnalyticsConsent(value) {
  if (value !== ANALYTICS_CONSENT_ACCEPTED && value !== ANALYTICS_CONSENT_REJECTED) return;
  if (typeof window === "undefined" || !window.localStorage) return;
  try {
    window.localStorage.setItem(ANALYTICS_CONSENT_KEY, value);
  } catch (_) {
    // Ignore storage failures so consent UI never blocks app usage.
  }
}

export function hasAnalyticsConsent() {
  return getAnalyticsConsent() === ANALYTICS_CONSENT_ACCEPTED;
}

export function isGaEnabled() {
  const hostname = getCurrentHostname().toLowerCase();
  if (!isValidMeasurementId(GA_MEASUREMENT_ID)) return false;
  if (!hostname) return false;
  return getAllowedHosts(GA_ALLOWED_HOSTS).includes(hostname);
}

export function isClarityEnabled() {
  const hostname = getCurrentHostname().toLowerCase();
  if (!isValidClarityProjectId(CLARITY_PROJECT_ID)) return false;
  if (!hostname) return false;
  return getAllowedHosts(CLARITY_ALLOWED_HOSTS).includes(hostname);
}

export function initGa() {
  if (!hasAnalyticsConsent()) return false;
  if (!isGaEnabled()) return false;
  if (window.gtag) return true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(
    GA_MEASUREMENT_ID
  )}`;
  document.head.appendChild(script);

  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID, {
    send_page_view: false,
  });

  return true;
}

export function initClarity() {
  if (!hasAnalyticsConsent()) return false;
  if (!isClarityEnabled()) return false;
  if (window.clarity) return true;

  window.clarity = function clarity() {
    window.clarity.q.push(arguments);
  };
  window.clarity.q = [];

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.clarity.ms/tag/${encodeURIComponent(CLARITY_PROJECT_ID)}`;
  document.head.appendChild(script);

  return true;
}

export function trackPageView(path) {
  if (!hasAnalyticsConsent()) return;
  if (!isGaEnabled() || !window.gtag) return;

  const pagePath = typeof path === "string" && path ? path : window.location.pathname;
  window.gtag("event", "page_view", {
    page_title: document.title,
    page_location: window.location.href,
    page_path: pagePath,
  });
}

export function trackEvent(name, params = {}) {
  if (!hasAnalyticsConsent()) return;
  if (!isGaEnabled() || !window.gtag) return;
  const eventName = typeof name === "string" ? name.trim() : "";
  if (!eventName) return;
  window.gtag("event", eventName, params && typeof params === "object" ? params : {});
}

export function setClarityTag(key, value) {
  if (!hasAnalyticsConsent()) return;
  if (!isClarityEnabled() || !window.clarity) return;
  const tagKey = typeof key === "string" ? key.trim() : "";
  if (!tagKey) return;
  window.clarity("set", tagKey, value);
}

export function trackClarityEvent(name) {
  if (!hasAnalyticsConsent()) return;
  if (!isClarityEnabled() || !window.clarity) return;
  const eventName = typeof name === "string" ? name.trim() : "";
  if (!eventName) return;
  window.clarity("event", eventName);
}
